import { render, staticRenderFns } from "./ValidadeLotes.vue?vue&type=template&id=4dcd73e6&scoped=true"
import script from "./ValidadeLotes.vue?vue&type=script&lang=js"
export * from "./ValidadeLotes.vue?vue&type=script&lang=js"
import style0 from "./ValidadeLotes.vue?vue&type=style&index=0&id=4dcd73e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcd73e6",
  null
  
)

export default component.exports